import posthog from "posthog-js"

type SearchRequestProperties = {
  request_id: string
  auto_crop: boolean
  has_crop: boolean
}

type SearchOutcomeProperties = SearchRequestProperties & { duration_ms: number }

type ImageSearchEvents = {
  image_search_opened: { variant: "icon" | "pill" }
  image_search_photo_selected: { source: "upload" | "drop" | "camera" }
  image_search_photo_rejected: {
    reason: "format" | "file_size" | "pixel_count" | "decode" | "multiple_files"
  }
  image_search_started: SearchRequestProperties
  image_search_completed: SearchOutcomeProperties & {
    result_count: number
    visible_result_count: number
    best_score: number | null
    processing_ms: number
    index_version: string
    attempt_id: string | null
  }
  image_search_failed: SearchOutcomeProperties & {
    reason: "invalid" | "unavailable"
    status_code: number | null
  }
  image_search_deferred: SearchOutcomeProperties & { reason: "processing" | "timeout" }
  image_search_recovery_timed_out: { request_id: string }
  image_search_cancelled: SearchOutcomeProperties
  image_search_recovered: {
    request_id: string
    outcome: "success" | "failed"
    result_count: number
  }
  image_search_filters_changed: {
    attempt_id: string | null
    category_ids: number[]
    include_less_similar: boolean
  }
  image_search_result_clicked: {
    attempt_id: string | null
    model_nr: string
    position: number
    score: number
  }
  image_search_feedback_saved: {
    attempt_id: string
    kind: "correct" | "none" | "removed"
    model_nr: string | null
  }
  image_search_feedback_clicked: { attempt_id: string | null }
  image_search_history_opened: Record<string, never>
}

// Keep event properties explicit: never send photos, filenames, URLs or raw errors.
export function sendImageSearchEvent<Event extends keyof ImageSearchEvents>(
  event: Event,
  properties: ImageSearchEvents[Event]
) {
  return posthog.capture(event, properties)
}
